import React from "react";
import ShippingPlaces from './ShippingPlaces.jsx';


const Deliveries = ({ selectedId, shippings, storeId, onChange, shippingPlaces, onChangePlace }) => {
	var T = window.Texts.checkout;
	return (
		<div className="box form-box delivery">
			<h2>{T.shipping}</h2>
			<ul>
				{shippings.map((shipping) => {
					var places = selectedId == shipping.id ? shippingPlaces['place' + shipping.id] : null;
					return (<li key={'shipping' + shipping.id} >
						<label className={(shipping.id == selectedId) ? 'active' : ''} >
							<input value={shipping.id} name="OrderDeliveryMethod" type="radio" checked={(shipping.id == selectedId)} onChange={(e)=>onChange(e)}/>
							{shipping.name}
							{places ? ' (' + places.length + ' prodejen)' : null}
							{window.Config.mode == 'liveua' ?
								<div className="xo-labelInside tarif">{(shipping.priceTable.totalPriceInclVat > 0) ? shipping.priceTable.displayTotalPriceInclVat : T.tarif}</div> :
								<div className="xo-labelInside">{(shipping.priceTable.totalPriceInclVat > 0) ? shipping.priceTable.displayTotalPriceInclVat : T.free}</div>}
							<div style={{ clear: 'both' }} />

						</label>
						{(places) ?
							<ShippingPlaces showOptions={(shipping.id == selectedId) && !storeId} selectedPlaceId={(shipping.id==selectedId)?storeId:null} places={places} onChange={(placeId) => onChangePlace(shipping.id,placeId)} /> : null}
					</li>);
				})}
			</ul>
		</div>
	);
}
export default Deliveries;
